import { FindMatchModal } from "./FindMatchModal"
import { FindTonMatchModal } from "./FindTonMatchModal"
import { PlayWithFriendModal } from "./PlayWithFriendModal"
import { TonMatchInfoModal } from "./TonMatchInfoModal"
import { TonRoomsModal } from "./TonRoomsModal"

export const MATCHMAKING_MODALS = {
  findMatch: {
    component: FindMatchModal
  },
  playWithFriend: {
    component: PlayWithFriendModal
  },
  findTonMatch: {
    component: FindTonMatchModal
  },
  tonRooms: {
    component: TonRoomsModal
  },
  tonMatchInfo: {
    component: TonMatchInfoModal
  }
} as const
